import { Component } from '@angular/core';

@Component({
  selector: 'app-commission-report',
  templateUrl: './commission-report.component.html',
  styleUrls: ['./commission-report.component.scss']
})
export class CommissionReportComponent {

}
